import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID, NIKECOM_CHANNEL, NIKE_BRAND } from '@nike/ux-tread-dotcom-constants';
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
import getURLBase from "../utils/get-url-base";
var createCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getWebShellClientLoc;
    var token, _yield$window$webShel, visitorId, visitId;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return window.webShellClient.identity.getAccessToken();
        case 1:
          token = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _yield$window$webShel = _context.sent;
          visitorId = _yield$window$webShel.visitorId;
          visitId = _yield$window$webShel.visitId;
          return _context.abrupt("return", fetchClient(getURLBase(), {
            headers: formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: DOTCOM_UX_ID
            }),
            method: 'PUT',
            credentials: 'include',
            body: JSON.stringify({
              id: window.crypto.randomUUID(),
              resourceType: 'cart',
              country: (_getWebShellClientLoc = getWebShellClientLocale().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase(),
              brand: NIKE_BRAND,
              channel: NIKECOM_CHANNEL,
              items: []
            })
          }, 'Error creating cart', {
            pageActionName: 'tread-cart-event'
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createCart() {
    return _ref.apply(this, arguments);
  };
}();
export default createCart;